<template>
<div>

    <div class="box partner-box" @click="partner_modal = true">
        <img src="https://assets.webbank.com/partners/ironhorse.png" alt="IronHorse Funding Logo">
    </div>

<div class="modal" :class="{'is-active': partner_modal}">
  <div class="modal-background"></div>
  <div class="modal-content">
      <div class="box has-text-left">
          <h2 class="box-title">Our Brand Partner</h2>
          <br>
          <div class="has-text-centered">
            <img src="https://assets.webbank.com/partners/ironhorse.png" alt="IronHorse Funding Logo">
          </div>
            <br>
            <p>In partnership with Ironhorse Funding, LLC, WebBank is the lender of consumer closed-end installment loans for the refinance of motorcycle products nationwide. If you have any questions about your loan, please call 978-993-7077 or visit
                <a href="#" title="Your account at Yamaha" @click="$emit('link-click', 'https://www.ironhorsefunding.com/motorcycle-refinance/')">here</a>.</p>
            <br>
            <p><a href="#" title="Ironhorse Funding Privacy Policy" @click="$emit('link-click', 'https://ironhorsefunding.com/wp-content/uploads/2022/05/IHFCustomerPrivacyNotice.pdf?_ga=2.2960304.1006960653.1660485036-1951162064.1660485036')">Ironhorse Funding Privacy Policy</a></p>
            <br>
            <p><a href="#" title="Ironhorse Funding Privacy Notice" @click="$emit('link-click', 'https://ironhorsefunding.com/wp-content/uploads/2022/05/IHFCustomerPrivacyNotice.pdf?_ga=2.148706807.139253999.1663708883-359396351.1663357456&_gac=1.217971044.1663357456.Cj0KCQjwvZCZBhCiARIsAPXbajvv7tdp9klvgruo9gs_tmms85QutTsI_c8jTgeQ-AJXFrk8IDVwnc0aAkegEALw_wcB')">Ironhorse Funding Privacy Notice</a></p>
            <br>
            <p><a href="#" title="WebBank Privacy Notice" @click="$emit('link-click', 'https://ironhorsefunding.com/wp-content/uploads/2022/05/WebBankCustomerPrivacyNotice.pdf?_ga=2.252665417.139253999.1663708883-359396351.1663357456&_gac=1.213957989.1663357456.Cj0KCQjwvZCZBhCiARIsAPXbajvv7tdp9klvgruo9gs_tmms85QutTsI_c8jTgeQ-AJXFrk8IDVwnc0aAkegEALw_wcB')">WebBank Privacy Notice</a></p>
            <br>
            <button class="button is-primary is-light" @click="partner_modal = false">Close</button>

      </div>
  </div>
  <button class="modal-close is-large" aria-label="close" @click="partner_modal = false"></button>
</div>

</div>
</template>

<script>
export default {
    data: function () {
        return {
            partner_modal: false,
        }
    }
}
</script>
